<div class="as-modal-container">
    <div class="as-row as-justify-end">
        <mat-icon svgIcon="ic-close-green" class="as-pointer" mat-dialog-close></mat-icon>
    </div>
    <div class="texts">
        <p class="as-font-20 as-font-black-gray as-font-bold">{{ 'HOME.TOOLBAR.attention' | translate }}</p>
        <p>{{ 'HOME.TOOLBAR.inviteToComplete' | translate }}</p>
    </div>
    <div class="btn-container">
        <button mat-flat-button color="accent" (click)="goProfile()">{{ 'HOME.TOOLBAR.goAccount' | translate }}</button>
        <button mat-stroked-button color="accent"
            mat-dialog-close>{{ 'HOME.TOOLBAR.anotherMoment' | translate }}</button>
    </div>
</div>